module.exports = __webpack_public_path__ + "img/product32_img05.795dfde4.png";